import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../redux/features/tasks/tasksApi";
import Task from "./Task";

export default function Tasks() {
  const { data: tasks, isLoading, isError, error } = useGetTasksQuery();
  const { filter, search } = useSelector((state) => state.filter);

  let content = null;

  // is loading
  if (isLoading) {
    content = <div>Loading...</div>;
  }

  // is not loading and error
  else if (!isLoading && isError) {
    content = <div>{error}</div>;
  }

  // is not loading and no error and no tasks
  else if (!isLoading && !isError && tasks?.length === 0) {
    content = <div>No Tasks Found!</div>;
  }

  // is not loading and no error and have tasks
  else if (!isLoading && !isError && tasks?.length > 0) {
    content = tasks
      .filter((task) =>
        task.taskName.toLowerCase().includes(search.toLowerCase())
      )
      .filter((task) => filter.includes(task.project.projectName))
      .map((task) => <Task key={task.id} task={task} />);
  }

  return <div className="lws-task-list">{content}</div>;
}
